import { useState } from 'react'
import './msg.css'
import Popup from '../util/Popup.js'
const EMAILSERVERADDRES = "https://www.newphasereno.ca/api"


function clearFields(){
  document.getElementById('nameField').value = ""
  document.getElementById('contactField').value = ""
  document.getElementById('inquiryField').value = ""
}

function Msg(para){
  const textData = para["textData"];
  const [popMsg, setPopMsg] = useState("")
  const [showSend,setShowSend] = useState(false)
  function validateEmail(){
    const contact = document.getElementById('contactField').value
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(emailRegex.test(contact)===false){
      setPopMsg(textData["notification_msg1"]);
      return false
    }
    setPopMsg("");
    return true;

  }
  function checkinput(){
    const name = document.getElementById('nameField').value
    const contact = document.getElementById('contactField').value
    const inquiry = document.getElementById('inquiryField').value
    setPopMsg("");
    if(name === "") return setShowSend(false);
    if(contact === "") return setShowSend(false);
    if(validateEmail() === false) return setShowSend(false);
    if(inquiry === "") return setShowSend(false);
    setShowSend(true)
  }
  
  function sedInquiry(){
    const name = document.getElementById('nameField').value;
    const contact = document.getElementById('contactField').value;
    const inquiry = document.getElementById('inquiryField').value;
    console.log("attempting to send email: ",name,contact,inquiry);
    let payload = {
      method:"POST",
      headers:{
        "content-type":"application.json"
      },
      body: JSON.stringify({
        "name":name,
        "contact":contact,
        "message":inquiry
      })
    }
    fetch(EMAILSERVERADDRES+"/sendEmail",payload).then(r=>{
      if(r.ok){
        clearFields();
        setPopMsg(textData["notification_msg2"]);
        setShowSend(false);
        setTimeout(()=>{setPopMsg("")},3000);
      }
      else{
        console.log(r);
        setPopMsg(textData["error_msg1"]);
        setTimeout(()=>{setPopMsg("")},3000);
      }
    }).catch(err=>{
      setPopMsg(textData["error_msg2"]);
      setTimeout(()=>{setPopMsg("")},3000);
      console.log(err);
    });

   
  }
  return(
    <div id = "messageInput">
      {popMsg !== ""&&<Popup message= {popMsg} color={"orange"}/>}
      <div id = "tableLabel">
        {textData["msg_header"]}
      </div>
      <div>
        <input 
            id = "nameField"
            placeholder={textData["msg_placeholder1"]}
            onChange={checkinput}
          />
      </div>

      <div>
        <input 
            type="email" 
            id = "contactField"
            placeholder={textData["msg_placeholder2"]}
            onChange={checkinput} 
          />
      </div>
      <div>
        <textarea 
            id = "inquiryField" 
            onChange={checkinput}
            placeholder={textData["msg_placeholder3"]}
          ></textarea>
      </div>
      <div>
        {showSend === true &&
            <button 
              id = "sendbutton" 
              onClick={sedInquiry}
            >{textData["msg_button"]}</button>
        }
      </div>
    </div>
  );
}
export default Msg;